var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { makeRemoteUserSession } from '@/main/factories/usecases/manage-user-session/manage-user-session';
import useUserSesssion from './use-user-session';
import { useRecoilState } from 'recoil';
import { lessonState } from '../pages/lessons/components/atoms';
import { useIdleTimer } from 'react-idle-timer';
// Define the interval in milliseconds
const MINUTES_MS = 1 * 60 * 1000; // 1 minute
const USER_IDLE_TIMEOUT = 1700000; // 28 minutes
const service = makeRemoteUserSession(); // Perhaps it would be better to consider making this a hook parameter.
function useUserTracker({ idModule, idLesson, isActive = true }) {
    const { user, isCognitoWatcher } = useUserSesssion();
    const [state, setState] = useRecoilState(lessonState);
    const [intervalId, setIntervalId] = useState(null);
    const trackLesson = () => __awaiter(this, void 0, void 0, function* () {
        try {
            console.log('Tracking lesson...');
            yield service.trackLesson({
                idUser: user.id,
                idModule: parseInt(idModule, 10),
                idLesson: parseInt(idLesson, 10),
                end: false
            });
        }
        catch (error) {
            console.error('Error tracking session:', error);
        }
    });
    useIdleTimer({
        onIdle: () => {
            clearInterval(intervalId);
            console.log('User is idle');
        },
        onActive: () => {
            console.log('User is active');
            // Call trackSession immediately on mount
            trackLesson();
            // Set interval to call trackSession every x minutes
            const intervalId = setInterval(trackLesson, MINUTES_MS);
            setIntervalId(intervalId);
        },
        timeout: USER_IDLE_TIMEOUT,
        throttle: 500
    });
    useEffect(() => {
        var _a;
        if (!isActive)
            return;
        if (process.env.REACT_APP_DISABLE_TRACK_SESSION)
            return;
        if (!idModule || !idLesson)
            return;
        if (!(user === null || user === void 0 ? void 0 : user.id))
            return;
        if (isCognitoWatcher) {
            console.info('Cognito watcher detected. Skipping session tracking.');
            return;
        }
        if (((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.description) !== 'Student')
            return;
        if (state.lessonCompleted)
            return;
        // Call trackSession immediately on mount
        trackLesson();
        // Set interval to call trackSession every x minutes
        const intervalId = setInterval(trackLesson, MINUTES_MS);
        setIntervalId(intervalId);
        // Clear the interval on component unmount
        return () => clearInterval(intervalId);
    }, [user === null || user === void 0 ? void 0 : user.id, idModule, idLesson, state === null || state === void 0 ? void 0 : state.lessonCompleted]);
}
export default useUserTracker;
